import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'

export default {
  namespaced: true,

  state: () => ({
    templates: [],
    allTemplates: [],
    loading: false,
    search: '',
    page: 1,
    limit: 100,
    totalPages: 10,
    selectedTemplateIds: [],
    response: null,
  }),

  getters: {
    templates: state => state.templates,
    allTemplates: state => state.allTemplates,
    loading: state => state.loading,
    search: state => state.search,
    page: state => state.page,
    limit: state => state.limit,
    totalPages: state => state.totalPages,
    selectedTemplateIds: state => state.selectedTemplateIds,
    isSelected: state => id => state.selectedTemplateIds.includes(id),
    response: state => state.response,
  },

  mutations: {
    SET_TEMPLATES(state, templates) {
      state.templates = templates
      templates.forEach(t => {
        if (!state.allTemplates.find(item => item.id === t.id)) {
          state.allTemplates.push(t)
        }
      })
    },
    CLEAR_ALL_TEMPLATES(state) {
      state.allTemplates = []
    },
    SET_LOADING(state, status) {
      state.loading = status
    },
    SET_SEARCH(state, search) {
      state.search = search
    },
    SET_PAGE(state, page) {
      state.page = page
    },
    SET_LIMIT(state, limit) {
      state.limit = limit
    },
    SET_TOTAL_PAGES(state, totalPages) {
      state.totalPages = totalPages
    },
    TOGGLE_SELECTED_TEMPLATE(state, id) {
      const index = state.selectedTemplateIds.indexOf(id)
      if (index >= 0) {
        state.selectedTemplateIds.splice(index, 1)
      } else {
        state.selectedTemplateIds.push(id)
      }
    },
    CLEAR_SELECTION(state) {
      state.selectedTemplateIds = []
    },
    SET_SELECTED_TEMPLATE(state, id) {
      state.selectedTemplateIds = [id]
    },
    SET_TEMPLATES_RESPONSE(state, response) {
      state.response = response;
    },
  },

  actions: {
    async fetchTemplates({ commit }, { customerId, search = '', page = 1, limit = 100, reset = false } = {}) {
      if (reset) commit('CLEAR_ALL_TEMPLATES')
      commit('SET_LOADING', true)
      commit('SET_SEARCH', search)
      commit('SET_PAGE', page)
      commit('SET_LIMIT', limit)

      try {
        const payload = {}
        if (search) payload.search = search
        if (page) payload.page = page
        if (limit) payload.limit = limit

        const { data } = await axios.post(`/banner/get-templates-paginated/${customerId}`, payload)
        commit('SET_TEMPLATES', data.data)
        commit('SET_TOTAL_PAGES', data.last_page || 10)
        commit('SET_TEMPLATES_RESPONSE', data)
      } catch (error) {
        console.error(`Error fetching templates for customer ${customerId}:`, error)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    getSelectedDataWithoutGrid({ state }) {
      const selected = state.allTemplates.filter(t => state.selectedTemplateIds.includes(t.id))
      if (!selected.length) return []
      const DEFAUL_GRID_COLUMNS = 12
      const maxWidth = Math.max(...selected.map(t => t.width || 0))
      const maxHeight = Math.max(...selected.map(t => t.height || 0))
      const maxSize = Math.max(maxWidth, maxHeight)
      let currentY = 0
      return selected.map(template => {
        const instanceId = template.instanceId || uuidv4()
        const w = Math.ceil(template.width * DEFAUL_GRID_COLUMNS / maxSize)
        const h = Math.ceil(template.height * DEFAUL_GRID_COLUMNS / maxSize)
        const result = {
          instance_id: instanceId,
          template_id: template.id,
          width: template.width,
          height: template.height,
          name: template.name,
          w,
          h,
          x: 0,
          y: currentY
        }
        currentY += h
        return result
      })
    }
  },
}